import { Link } from 'react-router-dom';

const langPrefixes = { en: '', zh: '/zh', ko: '/ko' };

function Footer({ t, nav, lang }) {
  const prefix = langPrefixes[lang] || '';

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-dark-secondary border-t border-gold/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <button onClick={scrollToTop} className="cursor-pointer">
              <img src="/logo.png" alt="Bunny Boy Massage" className="h-11 w-auto mb-4" />
            </button>
            <p className="text-white/50 text-sm font-montserrat leading-relaxed">{t.tagline}</p>
          </div>

          <div>
            <h4 className="font-montserrat text-xl text-gold mb-6">{t.links.title}</h4>
            <ul className="space-y-3">
              <li>
                <Link to={`${prefix}/`} className="text-white/60 hover:text-gold text-sm font-montserrat transition-colors">
                  {nav.home}
                </Link>
              </li>
              <li>
                <Link to={`${prefix}/erotic-massage-sukhumvit`} className="text-white/60 hover:text-gold text-sm font-montserrat transition-colors">
                  {nav.erotic}
                </Link>
              </li>
              <li>
                <Link to={`${prefix}/nuru-massage-sukhumvit`} className="text-white/60 hover:text-gold text-sm font-montserrat transition-colors">
                  {nav.nuru}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-montserrat text-xl text-gold mb-6">Contact</h4>
            <ul className="space-y-3 text-white/60 text-sm font-montserrat">
              <li>{t.hours}</li>
              <li>{t.location}</li>
              <li><a href="https://wa.me/66811103766" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors flex items-center space-x-2"><img src="/icon-whatsapp.png" alt="WhatsApp" className="w-5 h-5 object-contain inline-block" /><span>WhatsApp: 081-110-3766</span></a></li>
              <li><a href="https://line.me/ti/p/z2MKz54daM" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors flex items-center space-x-2"><img src="/icon-line.png" alt="LINE" className="w-5 h-5 object-contain inline-block" /><span>LINE: bunnyboybkk</span></a></li>
              <li><a href="tel:081-110-3766" className="hover:text-gold transition-colors">081-110-3766</a></li>
            </ul>
          </div>
        </div>

        <div className="section-divider mt-12 mb-8"></div>

        <div className="text-center text-white/30 text-xs font-montserrat">
          &copy; {t.copyright}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
